import {Box, Card, Container, Grid, Typography} from "@mui/material";
import Page from '../../components/Page';
import SpmChart from './SpmChart';

export default function Index() {
    return (
        <Page title="Dashboard Dinkes Sleman">
            <Container maxWidth="xl">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <Card
                            sx={{
                                mb: 4,
                                boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.4)',
                                '&:hover': {
                                    boxShadow: '-1px 2px 15px 0px rgba(0,0,0,0.2)'
                                }
                            }}
                        >
                            <Box sx={{ p: 4 }}>
                                <SpmChart
                                    tahun={`${new Date().getFullYear()}`}
                                    reload={1}
                                    forceReload={1}
                                />
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    )
}